export default "__VITE_ASSET__D2Sck8Tt__"